import { render, staticRenderFns } from "./DataMap.vue?vue&type=template&id=3c87ff26&scoped=true&"
import script from "./DataMap.vue?vue&type=script&lang=js&"
export * from "./DataMap.vue?vue&type=script&lang=js&"
import style0 from "./DataMap.vue?vue&type=style&index=0&id=3c87ff26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87ff26",
  null
  
)

export default component.exports